import { DEFAULT_TOKENS } from './tokens';

/** "#00B09B" -> "0 176 155" so we can use rgb(var(--x) / <alpha>) in Tailwind */
function hexToRgbTriple(hex) {
    if (!hex) return '0 0 0';
    const h = hex.replace('#', '').trim();
    const v = h.length === 3 ? h.split('').map(c => c + c).join('') : h;
    const n = parseInt(v, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255].join(' ');
}

/**
 * Apply a tokens-shaped object to <html> as CSS variables.
 * Safe to call repeatedly — every var is overwritten.
 */
export function applyTheme(tokens = {}) {
    const t = { ...DEFAULT_TOKENS, ...tokens, brand: { ...DEFAULT_TOKENS.brand, ...(tokens.brand || {}) }, ink: { ...DEFAULT_TOKENS.ink, ...(tokens.ink || {}) } };
    const root = document.documentElement;
    const setVar = (k, v) => root.style.setProperty(k, v);

    // brand
    Object.entries(t.brand).forEach(([k, v]) => {
        const slug = k.replace(/_/g, '-');
        setVar(`--ag-${slug}`, v);
        setVar(`--ag-${slug}-rgb`, hexToRgbTriple(v));
    });
    // ink
    Object.entries(t.ink).forEach(([k, v]) => {
        setVar(`--ink-${k}`, v);
        setVar(`--ink-${k}-rgb`, hexToRgbTriple(v));
    });
    // typography + misc
    setVar('--ag-font-heading', t.fontHeading);
    setVar('--ag-font-body',    t.fontBody);
    setVar('--ag-radius',       `${t.radius}px`);
    root.dataset.density = t.density || 'comfortable';
}
